import React from 'react'

export const ProductUndefinedScreen = () => {
  return (
    <div>No hay stock o está mal escrito el nombre</div>
  )
}
